import HeadlineWithDescription from './HeadlineWithDescription'

export default HeadlineWithDescription
